/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";
import Analytics from "analytics/util/Analytics";
import {
	OKEVENT,
	triggerOkEvent,
} from "shared/util/OkEventHelpers";
import getImageResizerPath from "shared/util/getImageResizerPath";

//#####################
/* PHOTO FINISHED */
//#####################

window.PhotoFinished = {
	// Mark as true to disable the photo finished screen
	disabled: false,

	// Mark as false to prevent reload of page after window dismissed
	reload: true,

	// Update success message
	updateSuccessMessage: false,

	init() {
		this.photo = $("#okphotos_cropped_photo");
		this.resetBtn = $("#upload_another");
		this.doneBtn = $("#done_uploading");
		this.message = $("#okphotos_finished .reassurance");

		this.resetBtn.on("click tap", () => {
			OkPhotos.switchAction("upload");
			ClientStats.update({ statname: "OkPhotos - upload another clicked" });
		});
		this.doneBtn.on("click tap", () => {
			if (this.reload) {
				OkPhotos.showLoader();
				window.location.reload();
			} else {
				OkPhotos.close();
			}
		});

		this.initialized = true;
	},

	// Callback for when the photo is uploaded and should be displayed here.
	// photo should have the following info:
	//  id	  - Self explanatory
	//  albumid - Self explanatory
	//  url	 - Complete url to the full size image
	//  path	- Path to the cropped image, with no size data
	//  crop	- left, top, right, bottom of the crop
	uploadCallback(photo) {
		// Fire upload stats
		let source;
		let destination = PhotoUploader.albumid ? "album" : "profile";

		ClientStats.update({
			statnames: [
				"OkPhotos - photo submitted",
				`OkPhotos - photo submitted to ${destination}`,
				`OkPhotos - photo submitted from ${PhotoUploader.uploadSource}`,
				`OkPhotos - photo submitted - referrer:${OkPhotos.referrer}`,
			],
		});

		// Temporary stat to appease staff robot
		if (PhotoUploader.uploadSource === "facebook") {
			window.util.updateStats(
				"PhotoUpload - uploaded from Facebook",
				1,
				"counter",
				"+MDa68GqcReBM8qd8uZzarky0nw="
			);
		}

		// Anything more than 7 minutes is considered idle time.
		let time = new Date().getTime();
		let diff = time - OkPhotos.startTime;
		if (diff < 420000) {
			window.util.updateStats(
				"OkPhotos - average completion ms",
				time - OkPhotos.startTime,
				"value",
				"5o0doSOnIE1PTDSXAeNuUm1ur28="
			);
		}

		// Trigger upload event
		triggerOkEvent(OKEVENT.PhotoUpload, {
			photo: {
				picid: photo.id,
				albumid: photo.albumid,
				url: photo.url,
				path: photo.path,
				square: photo.square || null,
				caption: photo.caption || null,
				crop: {
					topLeftX: photo.crop.left,
					topLeftY: photo.crop.top,
					bottomRightX: photo.crop.right,
					bottomRightY: photo.crop.bottom,
				},
			},
		});

		if (this.disabled) {
			OkPhotos.close();
			return;
		}

		if (this.updateSuccessMessage) {
			this.setMessage();
		}

		if (!PhotoUploader.albumid && OkPhotos.photoCount >= OkPhotos.maxPhotos) {
			if (this.reload) {
				PhotoEditor.editContainer.addClass("reloading");
				window.location.reload();
			} else {
				OkPhotos.close();
			}
		} else {
			PhotoFinished.photo.attr(
				"src",
				getImageResizerPath() + "/400x400/400x400/" + photo.path
			);
			OkPhotos.switchAction("finished");
		}

		let currentPage = (window.location.pathname || "/").split("/")[1];

		if (PhotoUploader.referrer === "profile") {
			source = "edit profile";
		} else if (PhotoUploader.referrer) {
			source = PhotoUploader.referrer.replace("_", " ");
		}

		// analytics crap
		let data = {
			"source of upload": source,
			"photo source": PhotoUploader.uploadSource,
			"photo count": 1,
		};

		Analytics.logUIEvent(Analytics.eventNames.uploadedPhoto, { data });
	},

	setMessage() {
		this.message != null || this.updateSuccessMessage
			? this.message.text(OkPhotos.getSuccessMessage())
			: undefined;
	},
};



// WEBPACK FOOTER //
// ./src/legacy/okphotos/photofinished.js